import React, { useContext, useState, useEffect } from "react";
import Service from "../../../API/Service"; 
import "./LoginPage.css";

import eyeIcon from "../../../Assets/icons/eye-icon.svg"; 
import eyeIconOpen from "../../../Assets/icons/eye-icon-open.svg"; 
import logo from "../../../Assets/logo-login.svg";
import { AuthContext } from "../../../context";

const ResetPassword = ({ setStep }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleResetPassword = async () => {
    if (!email) {
      setErrorMessage("Please enter your email.");
      
      return;
    }

    try {
      await Service.sendOtp(email); // Send OTP to the email
      setStep("otp"); // Move to OTP step
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error sending OTP.");
    }
  };

  return (
    <div className="reset-password">
      <div className="up">
        <h2 className="reset-title">Reset password</h2>
        <p className="reset-description">Enter your email address with which you were registered</p>
      </div>

      <div className="down">
      <div className="email">
        <p>Email</p>
        <input
          placeholder="Type your email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      {errorMessage && <div className="message">{errorMessage}</div>}

      <button className="login-btn" onClick={handleResetPassword}>
        Send reset email
      </button>

      </div>
      
      
    </div>
  );
};


const OtpConfirmation = ({ setStep }) => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(59);
  const [resendText, setResendText] = useState("Receive code again in 00:59");
  const [isError, setIsError] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      setIsError(false);

      if (value && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handleConfirm = async () => {
    if (code.includes("") || code.length < 6) {
      setErrorMessage("Please enter the full confirmation code.");
      return;
    }

    try {
      const otpCode = code.join("");
      await Service.checkOtp(otpCode); // Check OTP
      setStep("login"); // Redirect to login page or next step
    } catch (error) {
      setErrorMessage("Invalid OTP. Please try again.");
      console.error("Error confirming OTP:", error);
    }
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        setResendText(`Receive code again in 00:${timeLeft - 1 < 10 ? `0${timeLeft - 1}` : timeLeft - 1}`);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setResendText("Send");
      setResendDisabled(false);
    }
  }, [timeLeft]);

  const handleResendOtp = async () => {
    try {
      setResendDisabled(true);
      setTimeLeft(59);
      setResendText("Receive code again in 00:59");
      await Service.sendOtp(); // Resend OTP
    } catch (error) {
      console.error("Error resending OTP:", error);
    }
  };

  return (
    <div className="otp-confirmation">
      <div className="up">
        <h2 className="reset-title">Reset password</h2>
        <p className="reset-instruction">We have sent a one-time password to your email</p>
      </div>

      <div className="codeBlock">
      <p className="reset-description">Enter the confirmation code from the email below</p>

        <div className="codeInputContainer">
          {code.map((digit, index) => (
            <input
              key={index}
              id={`code-input-${index}`}
              placeholder="0"
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className={`codeInput ${isError ? "error" : ""}`}
            />
          ))}
        </div>

        <button
          className="resendButton"
          disabled={resendDisabled}
          onClick={handleResendOtp}
        >
          {resendText}
        </button>

        {errorMessage && <div className="message">{errorMessage}</div>}

        <button className="confirmButton" onClick={handleConfirm}>
          Confirm
        </button>
      </div>
    </div>
  );
};


const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); 
  const [step, setStep] = useState("login");

  const { setIsAuth } = useContext(AuthContext);

  const login = event => {
    event.preventDefault();
    let login = document.getElementById('login').value;
    let password = document.getElementById('password').value;

    Service.pushLogin(login, password)
      .then(response => {
        if (response.status === 200) {
          setIsAuth(true);
          localStorage.setItem('auth', 'true');
          setErrorMessage(""); 
        } else {
          setIsAuth(false);
          setErrorMessage(response.data?.message || "Try again");
          console.error("Login failed:", response.data);
        }
      })
      .catch(error => {
        setIsAuth(false);
        setErrorMessage(error.response?.data?.message || "Login failed");
      });
  };

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000); 

      return () => clearTimeout(timer); 
    }
  }, [errorMessage]);

  return (
    <div className="login-wrap">
      <div className="left">

      {step === "login" && (
          <>
        <h1>Log in</h1>
        <form onSubmit={login}>

          <div className="email">
            <p>Email</p>
            <input placeholder="Type your email" type="text" id="login" />
          </div>

          <div className="pass">
            <p>Password</p>
            <input 
              placeholder="Type your password"  
              type={showPassword ? "text" : "password"} 
              id="password"
            />
            <img 
              src={showPassword ? eyeIconOpen : eyeIcon} 
              alt="Toggle Password" 
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)} 
            />
          </div>

          {errorMessage && <div className="message">{errorMessage}</div>}

          <div className="remember-forget">
            <label>
              <input type="checkbox" />
              Remember me
            </label>
            <div onClick={() => setStep("reset")}>Forgot password?</div>
          </div>

          <button className="login-btn">
            Log in
          </button>

        </form>
        </>
        )}

        {step === "reset" && <ResetPassword setStep={setStep} />}
        {step === "otp" && <OtpConfirmation setStep={setStep} />}
      </div>

      <div className="right">
        <img src={logo} alt="Logo" />
      </div>
    </div>
  );
};

export default Login;
